import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { CSSTransition } from "react-transition-group";
import styles from "./styles.module.scss";
import { useRef } from "react";

export const ModalContainer = NiceModal.create(({ children }) => {
  const modalRef = useRef(null);
  const modal = useModal();

  return (
    <CSSTransition
      in={modal.visible}
      timeout={800}
      classNames={{
        enter: styles.modalEnter,
        enterActive: styles.modalEnterActive,
        exit: styles.modalExit,
        exitActive: styles.modalExitActive,
      }}
      unmountOnExit
      nodeRef={modalRef}
    >
      <div ref={modalRef} className={styles.modalOverlay}>
        <div className={styles.content}>{children}</div>
      </div>
    </CSSTransition>
  );
});
